import clsx from 'clsx';
import { useMemo } from 'react';

// oxlint-disable-next-line react-refresh/only-export-components
const Card_ = (props: React.ComponentProps<'div'>) => {
  const { children, className, ...rest } = props;
  return (
    <CardBase {...rest} className={className}>
      <CardContent>{children}</CardContent>
    </CardBase>
  );
};

// oxlint-disable-next-line react-refresh/only-export-components
const CardBase = (props: React.ComponentProps<'div'>) => {
  const { className, ...rest } = props;
  return (
    <div
      {...rest}
      className={clsx(
        'relative isolate rounded-2xl bg-white text-[#031839] shadow-[2px_4px_25px_5px_rgba(0,0,0,0.05)]',
        'has-data-[slot=blurry-circle]:mt-14 has-data-[slot=blurry-circle]:pt-4 sm:has-data-[slot=blurry-circle]:pt-6',
        className,
      )}
    />
  );
};

// oxlint-disable-next-line react-refresh/only-export-components
const CardContent = (
  props: React.ComponentProps<'div'> & {
    noPadding?: boolean | 'top' | 'bottom' | 'left' | 'right' | 'x' | 'y';
  },
) => {
  const { noPadding, className, ...rest } = props;

  const padding = useMemo((): string => {
    switch (noPadding) {
      case true:
        return '';
      case false:
      case undefined:
        return 'p-6';
      case 'top':
        return 'p-6 pt-0';
      case 'bottom':
        return 'p-6 pb-0';
      case 'left':
        return 'p-6 pl-0';
      case 'right':
        return 'p-6 pr-0';
      case 'x':
        return 'p-6 px-0';
      case 'y':
        return 'p-6 py-0';
    }
  }, [noPadding]);

  return <div {...rest} className={clsx('flex flex-col', padding, className)} />;
};

export const Card = Object.assign(Card_, {
  Base: CardBase,
  Content: CardContent,
});
